export default "__VITE_ASSET__Sz4OGISZ__"